import React, { useEffect } from "react";
import cx from "classnames";

const Textarea = ({ className, ...props }) => {
  useEffect(() => {
    if (props.defaultValue) props.onChange(props.defaultValue);
  }, []);

  return (
    <textarea
      className={cx(
        "input-field block h-114 relative font-mulish text-14 text-gray-text leading-16 tracking-2 w-full px-12 py-15 border border-gray-med rounded-sm outline-none focus:border-blue-ayana z-1 appearance-none",
        className
      )}
      {...props}
    />
  );
};
Textarea.defaultProps = {
  className: "",
};
export default Textarea;
